<!-- =========================================================================================
    File Name: LockScreen.vue
    Description: Lock Screen Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="flex w-full bg-img vx-row no-gutter justify-center items-center">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card class="mt-6">
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/lock-screen.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Solicitar soporte</h4>
                                </div>
                                
                                <div class="mb-3">
                                    <vs-input icon-no-border icon="icon icon-user" icon-pack="feather" label-placeholder="Nombre" v-model="value1" class="w-full mb-6"/>
                                    <vs-input type="text" class="w-full mb-6"
                                        icon-pack="feather" label-placeholder="Titulo" icon="icon-message-square" icon-no-border v-model="input6"
                                     />
                                    <vs-textarea class="mb-6" label="Mensaje de soporte" v-model="textarea" />
                                    <p class="mb-2" >Tipo de Soporte</p>
                                    <v-select class="mb-6" :options="['Preguntas','Errores de funcionamiento', 'Nueva Funcionalidad']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                </div>
                               
                                <div class="flex justify-between flex-wrap">
                                    <router-link to="/pages/login" class="mb-4">Prefieres un correo?</router-link>
                                    <vs-button class="ml-2">Envíar</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  data () {
    return {
      value1: '',
      value2: ''
    }
  },
  components: {
      vSelect
  }
}
</script>
